import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { SubmitHandler } from 'react-hook-form';
import { useNavigate } from '@tanstack/react-router';
import { useCreateDocumentRequest } from '@area-restrita/api-client/endpoints/document-request/document-request.gen';

import PageContainer from '@/components/layout/PageContainer';

import CompanyDocumentRequestForm from '../../components/company-document-request-form';
import { type CompanyDocumentRequestSchema } from '../../components/company-document-request-form/schema';

const CompanyNewDocumentRequest: React.FC = () => {
  const navigate = useNavigate();

  const { mutateAsync } = useCreateDocumentRequest({
    mutation: {
      onSuccess: () => {
        toast.success('Solicitação criada com sucesso');
        navigate({ to: '/my-document-requests' });
      },
      onError: () => {
        toast.error('Erro ao criar solicitação');
      },
    },
  });

  const handleSubmit = useCallback<SubmitHandler<CompanyDocumentRequestSchema>>(
    (data) =>
      mutateAsync({
        data: {
          status: 'request',
          reason: data.reason.value,
          reasonFields: data.reasonFields,
          observation: data.observation,
          companyDocumentPublicId: data.document.value,
          implantationDate: data.dateForApproval,
        },
      }),
    [mutateAsync],
  );

  return (
    <PageContainer title="Nova solicitação de alteração">
      <CompanyDocumentRequestForm onSubmit={handleSubmit} canSave />
    </PageContainer>
  );
};

export default CompanyNewDocumentRequest;
